<template>
  <div>
    <nav class="bg-gray-800">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center text-white">
              <a target="_blank" :href="'/outfitter/' + outfitter.slug"
                >White Water Photography - {{ outfitter.name }}</a
              >
            </div>
          </div>
          <div class="flex items-center text-white">
            Welcome {{ user.name }}
          </div>
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <span class="rounded-md shadow-sm">
                <base-button-white
                  v-if="adminId"
                  @click="handleAdmin"
                  class="mr-3"
                  >Admin</base-button-white
                >
                <button
                  v-on:click="logout"
                  type="button"
                  class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-400 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-600 active:bg-indigo-600 transition duration-150 ease-in-out"
                >
                  <span>Log Out</span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import BaseButtonWhite from "@/components/ui/buttons/BaseButtonWhite";
export default {
  name: "DashboardNav",
  components: { BaseButtonWhite },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          this.$router.push("/");
        })
        .catch();
    },
    handleAdmin() {
      this.$store.dispatch("auth/login_as_back", this.adminId).then((resp) => {
        if (!resp.success) return;

        window.location.href = "/admin";
      });
    },
  },
  computed: {
    outfitter: function () {
      return this.$store.getters["outfitter/getOutfitter"];
    },
    user: function () {
      return this.$store.getters["auth/getUser"];
    },
    adminId: function () {
      return this.$store.getters["auth/adminId"];
    },
  },
  mounted() {},
};
</script>
